var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('the-layout',[(_vm.loading)?_c('van-loading',{attrs:{"size":"24px","vertical":""}},[_vm._v(_vm._s(_vm.loadingText))]):[(_vm.error)?_c('van-empty',{attrs:{"image":"error","description":_vm.errorText}}):_vm._t("default")]],2)}
var staticRenderFns = []

export { render, staticRenderFns }